<template>
  <div class="section"
       :id="blockData.title">
    <div class="title"
         :style="{backgroundImage: `url(${titleImage})`}"></div>
    <div class="video-wrap">
      <div class="video-player">
        <div class="yellow-block"></div>
        <template v-for="(item,index) in blockData.list">
          <iframe :key="index"
                  v-if="item.url && currentIndex==index "
                  :src="getIframeSrc(item.url)"
                  frameborder="0"></iframe>
        </template>

      </div>

      <div class="video-list">
        <ul>
          <template v-for="(item,index) in blockData.list">
            <li class="video-item"
                v-if="item.url"
                :key="index"
                :class="{on:index==currentIndex}"
                @click="currentIndex=index">
              <div class="pic">
                <img :src="getPicSrc(item.pic)"
                     :alt="item.subtitle"
                     :title="item.subtitle">
              </div>
              <div class="item-r">
                <div class="item-title ellipsis"
                     :title="item.subtitle">{{item.subtitle}}</div>
                <!-- <div class="item-desc ellipsis"
                   title="这是副标题">这是副标题</div> -->
              </div>
            </li>
          </template>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    blockData: {
      default: {}
    }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  computed: {
    titleImage () {
      return require(`../../../assets/images/pc/title/${this.blockData.title}.png`)
    }
  },
  methods: {
    getPicSrc (pic) {
      if (pic) {
        return require(`../../../assets/pic/best-videos/${pic}`)
      }
      return ''
    },
    getIframeSrc (src) {
      src.match(/https?:\/\/(?:v\.)?qq.com\/x\/page\/([\da-zA-Z]+)\.html/);
      let url = ''
      if (RegExp.$1) {
        url = '//v.qq.com/txp/iframe/player.html?vid=' + RegExp.$1 + '&width=' + 662 + '&height=' + 496 + '&auto=0'
      }
      return url
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  padding: 57px 0 57px;
  background: url(../../../assets/images/pc/title/best-videos.png) no-repeat
    center center;
  background-size: auto 36px;
}
.video-wrap {
  width: 1080px;
  margin: 0 auto;
  background-color: #fff;
  padding: 24px 41px 39px;
  display: flex;
  box-sizing: border-box;
}
.yellow-block {
  width: 76px;
  height: 13px;
  background-color: #fee23f;
}
iframe {
  width: 662px;
  height: 496px;
  background-color: #d8d8d8;
}
.video-list {
  flex: 1;
  padding-left: 49px;
  margin-top: 13px;
  height: 496px;
  overflow-y: auto;
}
.video-item {
  position: relative;
  display: flex;
  cursor: pointer;
  & + .video-item {
    margin-top: 12px;
  }
  &.on {
    &:before {
      content: "";
      display: block;
      position: absolute;
      width: 21px;
      height: 21px;
      background: url(../../../assets/images/pc/arrow.png) no-repeat center
        center;
      background-size: auto 100%;
      top: 34.5px;
      left: -32px;
    }
  }
  .pic {
    width: 127px;
    height: 90px;
    background-color: #d8d8d8;
    overflow: hidden;
    position: relative;
  }
  img {
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
.item-r {
  width: 144px;
  margin-left: 16px;
  padding-top: 7px;
}
.item-title {
  color: #333;
  font-size: 16px;
  line-height: 22px;
  max-height: 66px;
  font-weight: bold;
}
.item-desc {
  color: #b3b3b3;
  font-size: 14px;
  line-height: 20px;
  max-height: 40px;
  margin-top: 6px;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>